import { css, keyframes } from 'styled-components';

export const fontSnippets = {
    BS: 'font-family: "BS"; font-style: normal; font-weight: bold;',
    roboto: 'font-family: "Roboto", sans-serif; font-style: normal; font-weight: 400;',
    robotoSemi: 'font-family: "Roboto", sans-serif; font-style: normal; font-weight: 600;',
    robotoBold: 'font-family: "Roboto", sans-serif; font-style: normal; font-weight: 600;',
}

export const size = {
    mobileS: '320px',
    mobileM: '375px',
    mobileL: '425px',
    tablet: '768px',
    laptop: '1170px',
    laptopL: '1440px',
    desktop: '2560px'
}

export const device = {
    mobileS: `(min-width: ${size.mobileS})`,
    mobileM: `(min-width: ${size.mobileM})`,
    mobileL: `(min-width: ${size.mobileL})`,
    tablet: `(min-width: ${size.tablet})`,
    laptop: `(min-width: ${size.laptop})`,
    laptopL: `(min-width: ${size.laptopL})`,
    desktop: `(min-width: ${size.desktop})`,
    desktopL: `(min-width: ${size.desktop})`
};

export const elementSize = {
    headerHeight: '10rem',
    mobileHeaderHeight: '70px',
}

export const basicColor = {
    white: '#FFF',
    lightGrey: '#F1F4F7',
    faintGray: '#D9E1E6',

    midGray: '#beccd5',
    darkGray: '#8A9CAB',
    black: '#5E5E73',
    deepDark: '#3D4156',

    midGrayDarkTheme: '#595f73',
    darkGrayDarkTheme: '#474c5c',
    blackDarkTheme: '#292d38',
    deepDarkDarkTheme: '#1f2129',

    transparent: 'rgba(0, 0, 0, 0.25)',
    primary: '#009DE9',
    primaryTransparent: 'rgba(0, 157, 233, 0.2)',
    primaryLight: '#3DBDFF',
    secondary: '#a4d784',
    secondaryTransparent: 'rgba(174, 226, 142, 0.2)',
    secondaryDark: '#8DC16D',
    accent: '#FAC248',
    accentDark: '#E2941F',
    accentTransparent: 'rgba(250, 194, 72, 0.2)',
    red: '#FA7079',
    redTransparent: 'rgba(250, 112, 121, 0.2)',
}

export const gradient = {
    primary: 'linear-gradient(308.92deg, #96EDFF -1.36%, #02A0EA 92.91%)',
    green: 'linear-gradient(105.44deg, #55CF88 2.25%, #CBE994 100%)',
    orange: 'linear-gradient(105.44deg, #FB9F6C 2.25%, #FFCF58 100%)',
    purple: 'linear-gradient(105.44deg, #BA68C8 2.25%, #FFB7D6 100%)',
}

export const testBackground = {
    primary: '#5f5e7b',
    secondary: '#6B6FBC',
    brightDark: '#48467A',
    darkBlue: '#29549C',
    brightGreen: '#3C9AB1',
    neutral: '#595A5D',
}

export const radius = {
    large: '10px',
    normal: '5px',
}


export const boxShadow = {
    small: '0px 1px 2px rgba(0, 0, 0, 0.05)',
    normal: '8px 14px 21px rgba(163, 172, 181, 0.23)',
    middle: '1px 33px 20px rgba(166, 176, 185, 0.0920837)',
    long: '-1px -33px 20px rgba(166, 176, 185, 0.0920837), 0px 50px 64px rgba(186, 194, 202, 0.4)',
    extreme: '1px 50px 64px rgba(24, 29, 79, 0.15), -1px -2px 20px rgba(24, 29, 79, 0.1)',
}


export const padding = {
    xLarge: '8rem',
    large: '6rem',
    normal: '3rem',
    small: '2rem',
    xSmall: '1rem',
}

export const font = {
    basic: `${fontSnippets.roboto} font-size: 2.25rem; line-height: 3.5rem;`,
    basicBig: `${fontSnippets.roboto} font-size: 2.75rem; line-height: 3.5rem;`,
    basicS: `${fontSnippets.roboto} font-size: 2rem; line-height: 2.5rem;`,
    basicBoldS: `${fontSnippets.robotoSemi} font-size: 2rem; line-height: 2.5rem;`,
    basicXS: `${fontSnippets.roboto} font-size: 1.75rem; line-height: 2.625rem;`,
    basicBoldXS: `${fontSnippets.robotoSemi} font-size: 1.5rem; line-height: 2rem; letter-spacing: 0.5px;`,
    accentXL: `${fontSnippets.BS} font-size: 4rem;`,
    accentL: `${fontSnippets.BS} font-size: 2.5rem;`,
    accentM: `${fontSnippets.BS} font-size: 2.25rem;`,
    accentS: `${fontSnippets.BS} font-size: 2rem; letter-spacing: 0.2px;`,
    upperCase: `${fontSnippets.robotoSemi} font-size: 1.25rem; line-height: 2rem; letter-spacing: 2px; text-transform: uppercase;`,

    mobile: {
        h1: `${fontSnippets.robotoBold} font-size: 4rem; line-height: 5rem;`,
        h2: `${fontSnippets.robotoBold} font-size: 22px; line-height: 4rem;`,
        h3: `${fontSnippets.robotoBold} font-size: 2.5rem; line-height: 4rem;`,
        h4: `${fontSnippets.robotoBold} font-size: 18px; line-height: 3.25rem;`,
    },

    desktop: {
        h1: `${fontSnippets.robotoBold} font-size: 7rem; line-height: 8rem;`,
        h2: `${fontSnippets.robotoBold} font-size: 4rem; line-height: 42px;`,
        h3: `${fontSnippets.robotoBold} font-size: 3rem; line-height: 4rem;`,
        h4: `${fontSnippets.robotoBold} font-size: 2.5rem; line-height: 3.25rem;`,
    },


    text: {
        captionSmall: `${fontSnippets.BS} font-size: 1.75rem;`,
        captionXSmall: `${fontSnippets.BS} font-size: 1.5rem; line-height: 2rem; -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;`,
    },
}



export const transition = {
    fastEnd: '0.4s cubic-bezier(.91,.8,.27,1.19)'
}

export const bounceIn = keyframes`
    0% {
        opacity: 0;
        transform: scale(0.3) translate3d(0,0,0);
    }
    
    50% {
        opacity: 0.9;
        transform: scale(1.1);
    }
    
    80% {
        opacity: 1;
        transform: scale(0.89);
    }
    
    100% {
        opacity: 1;
        transform: scale(1) translate3d(0,0,0);
    }
`;

export const fadeIn = keyframes`
    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
`;

export const appearanceAnimation =  keyframes`
    0% { transform: scale(0.9); opacity: 0 }
    50% { transform: scale(1.1); opacity: .7; }
    100% { transform: scale(1); opacity: 1 }
`;

export const slideIn = keyframes`
    0% {transform: scale(1,1) translateY(100%);}
    10% {transform: scale(1.1,.9) translateY(50%);}
    30% {transform: scale(.9,1.1) translateY(0);}
    50% {transform: scale(1) translateY(7px);}
    100% {transform: scale(1) translateY(0);}
`;

export const slideFromTop = keyframes`
  0% {
    transform: translateY(-100%) scaleY(0.8);
    opacity: 0;
  }
  50% {
    transform: translateY(0) scaleY(1.05);
    opacity: 1;
  }
  70% {
    transform: translateY(-5px) scaleY(0.95);
  }
  90% {
    transform: translateY(0) scaleY(1.02);
  }
  100% {
    transform: translateY(0) scaleY(1);
  }
`;

export const Spin = keyframes`
    0% {
        -webkit-transform: rotate(0deg) scale(1);
        transform: rotate(0deg) scale(1);
    }

    50% {
        -webkit-transform: rotate(360deg) scale(1.3);
        transform: rotate(360deg) scale(1.3);
    }

    100% {
        -webkit-transform: scale(1);
        transform: scale(1);
    }
`;


export const AnimatedAppearance = css`
    animation: ${fadeIn} 0.5s ease-in-out forwards;
`;

